module.exports = __webpack_public_path__ + "static/media/blackOlive.c0531423.png";